import React from "react";
import CircularProgressbar from "react-circular-progressbar";
import PropTypes from "prop-types";

export default class Competence extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    var done = (
      <div className="done">
        {!this.props.averageScore ? "-" : false}
        {this.props.averageScore && this.props.averageScore === 1 ? "O" : false}
        {this.props.averageScore && this.props.averageScore === 2 ? "VVV" : false}
        {this.props.averageScore && this.props.averageScore === 3 ? "V" : false}
        {this.props.averageScore && this.props.averageScore === 4 ? "G" : false}
      </div>
    );

    return (
      <div className={"competence" + (this.props.isActive ? " active" : "")}>
        <div className="competence-value">{this.props.percentage === 100 ? done : <i className="fa fa-ellipsis-h" />}</div>
        <CircularProgressbar percentage={this.props.percentage} strokeWidth={6} textForPercentage={(pct) => ""} />
        <div className="competence-name">{this.props.name}</div>
      </div>
    );
  }
}

Competence.propTypes = {
  name: PropTypes.string,
  percentage: PropTypes.number.isRequired,
  isActive: PropTypes.bool
};

Competence.defaultProps = {
  name: "",
  percentage: 0,
  isActive: false
};



// WEBPACK FOOTER //
// ./components/Competence.js